const exposureTime = 5000
const contractAddress = '0x043c471bEe060e00A56CcD02c0Ca286808a5A436'

export { exposureTime, contractAddress }
